document.addEventListener('DOMContentLoaded', (event) => {
    const label_color = document.getElementById('label-color');
    const color_fijo = label_color.getAttribute('data-color');
    let colores_arreglo = Array.from(document.getElementsByClassName('colores-item'));
    colores_arreglo.forEach((item) => {
      item.addEventListener('mouseover', () => {
          // Obtener el valor del atributo 'data-color'
          let color = item.getAttribute('data-color');
          // Cambiar el texto del elemento con id 'texto-color'
          label_color.textContent = color;
        });

        item.addEventListener('mouseout', () => {
          // Restaurar el texto original cuando el cursor salga del elemento
          label_color.textContent = color_fijo;
        });
    });
});